(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
gtag('js', new Date());
    // Jedno jawne page_view. Automatyczna odslona z config jest wylaczona,
    // zeby opoznione doladowanie gtag.js ani inne skrypty nie mogly policzyc
    // tej samej strony drugi raz. Pelny URL bez parametrow chroni prywatne
    // dane analizatora i daje GA4 jednoznaczna strone docelowa sesji.
    gtag('config', __pewniaki_inline_cfg[0], {
        'anonymize_ip': true,
        'page_location': location.origin + location.pathname,
        'send_page_view': false
    });
    gtag('event', 'page_view', {
        'page_title': document.title,
        'page_location': location.origin + location.pathname
    });
    (function () {
        'use strict';
        var zaladowane = false;
        var adres = __pewniaki_inline_cfg[1];
        function zaladujAnalityke() {
            if (zaladowane) { return; }
            zaladowane = true;
            var skrypt = document.createElement('script');
            skrypt.async = true;
            skrypt.src = adres;
            document.head.appendChild(skrypt);
        }
        function poZaladowaniu() {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(zaladujAnalityke, { timeout: 6000 });
            } else {
                window.setTimeout(zaladujAnalityke, 6000);
            }
        }
        ['pointerdown', 'keydown', 'touchstart'].forEach(function (zdarzenie) {
            window.addEventListener(zdarzenie, zaladujAnalityke, { once: true, passive: true });
        });
        if (document.readyState === 'complete') { poZaladowaniu(); }
        else { window.addEventListener('load', poZaladowaniu, { once: true }); }
        // Pierwsza interakcja nadal uruchamia pomiar natychmiast. Dłuższy
        // bezpiecznik chroni pierwszy render na urządzeniach mobilnych, a
        // kolejka gtag zachowuje konfigurację i pojedynczą odsłonę strony.
        window.setTimeout(zaladujAnalityke, 10000);
    })();
})();
